import { Injectable } from '@angular/core';
import * as jQuery from 'jquery';
@Injectable({ providedIn: 'root' })
export class JiraIssueCollectorService {
    public createJiraEvent(jiraIssueCollectorUrl: string, description: string): void {
        jQuery.ajax(jiraIssueCollectorUrl, {
            type: 'get',
            cache: true,
            dataType: 'script',
            crossDomain: true
        });
        window.ATL_JQ_PAGE_PROPS = {
            triggerFunction: (showCollectorDialog: () => void) => {
                //Requires that jQuery is available!
                showCollectorDialog();
            },
            fieldValues: {
                description
            }
        };
    }

    public createJiraLink([displayText, url]: [string, string]): string {
        return `[${displayText}|${url}]`;
    }
}
